import { useSelector } from 'react-redux';
import { EntityStatementOfFactsConfig } from '../../models/reports.interface';
import { selectedEntityStatementOfFactsConfig } from '../../selectors';

export const useSelectedEntityStatementsOfFacts = (): EntityStatementOfFactsConfig => {
  const entityStatementsOfFactsConfig = useSelector(selectedEntityStatementOfFactsConfig);

  return entityStatementsOfFactsConfig;
};
